import { render } from "./AddManufacturer.vue?vue&type=template&id=c67a1c36&ts=true"
import script from "./AddManufacturer.vue?vue&type=script&lang=ts"
export * from "./AddManufacturer.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__